// Badge — colored pill label
// Usage: <Badge color={var(--teal)} bg={var(--teal-t)}>Done</Badge>
// Or use the helper: <StatusBadge status="done" />

export function Badge({ color, bg, children, style }) {
  return (
    <span
      className="bdg"
      style={{
        color,
        background: bg,
        borderColor: color ? `${color}44` : 'transparent',
        ...style,
      }}
    >
      {children}
    </span>
  );
}

const STATUS_MAP = {
  done:    { color: 'var(--teal)', bg: 'var(--teal-t)', label: 'Done' },
  active:  { color: 'var(--teal)', bg: 'var(--teal-t)', label: 'Active' },
  pending: { color: 'var(--t3)',   bg: 'rgba(74,106,136,.12)', label: 'Pending' },
  paid:    { color: 'var(--teal)', bg: 'var(--teal-t)', label: 'Paid' },
  sent:    { color: 'var(--cyan)', bg: 'var(--cyan-t)', label: 'Sent' },
  overdue: { color: 'var(--rose)', bg: 'var(--rose-t)', label: 'Overdue' },
  at_risk: { color: 'var(--amber)', bg: 'var(--amber-t)', label: 'At Risk' },
};

export function StatusBadge({ status }) {
  const cfg = STATUS_MAP[status] || { color: 'var(--t3)', bg: 'rgba(74,106,136,.12)', label: status };
  return <Badge color={cfg.color} bg={cfg.bg}>{cfg.label}</Badge>;
}
